import { jsx as e } from "react/jsx-runtime";
import { ApplePayIcon as o } from "./apple-pay-icon.mjs";
import { BancontactStripeIcon as t } from "./bancontact-stripe-icon.mjs";
import { KlarnaIcon as n } from "./klarna-icon.mjs";
import { MultibancoIcon as m } from "./multibanco-icon.mjs";
import { BoletoIcon as _ } from "./boleto-icon.mjs";
import { PixIcon as i } from "./pix-icon.mjs";
import { PayPalIcon as s } from "./paypal-icon.mjs";
import { RazorpayIcon as d } from "./razorpay-icon.mjs";
import { FlutterwaveIcon as l } from "./flutterwave-icon.mjs";
import { MollieIcon as p } from "./mollie-icon.mjs";
import { GocardlessIcon as u } from "./gocardless-icon.mjs";
import { CashOnDeliveryIcon as f } from "./cash-on-delivery-icon.mjs";
import { XenditIcon as y } from "./xendit-icon.mjs";
import { PaystackIcon as I } from "./paystack-icon.mjs";
import { IDealStripeIcon as g } from "./ideal-stripe-icon.mjs";
import { CreditCardIcon as k } from "./creadit-card-icon.mjs";
import { PaymentMethodEnum as a } from "../enums/payment-methods/payment-method.enum.mjs";
const O = (c, r) => {
  switch (c) {
    case a.stripe_card:
    case a.dlocal_card:
    case a.mercadopago_br_card:
    case a.mercadopago_ar_card:
    case a.mercadopago_co_card:
    case a.mercadopago_mx_card:
    case a.mercadopago_cl_card:
    case a.secure_and_pay:
      return /* @__PURE__ */ e(k, { ...r });
    case a.stripe_applepay:
      return /* @__PURE__ */ e(o, { ...r });
    case a.stripe_ideal:
      return /* @__PURE__ */ e(g, { ...r });
    case a.stripe_bancontact:
      return /* @__PURE__ */ e(t, { ...r });
    case a.stripe_klarna:
      return /* @__PURE__ */ e(n, { ...r });
    case a.stripe_multibanco:
      return /* @__PURE__ */ e(m, { ...r });
    case a.dlocal_boleto:
    case a.mercadopago_br_boleto:
      return /* @__PURE__ */ e(_, { ...r });
    case a.dlocal_pix:
    case a.mercadopago_br_pix:
      return /* @__PURE__ */ e(i, { ...r });
    case a.paypal_soap:
    case a.paypal_rest:
      return /* @__PURE__ */ e(s, { ...r });
    case a.razorpay:
      return /* @__PURE__ */ e(d, { ...r });
    case a.flutterwave:
      return /* @__PURE__ */ e(l, { ...r });
    case a.mollie:
      return /* @__PURE__ */ e(p, { ...r });
    case a.gocardless:
      return /* @__PURE__ */ e(u, { ...r });
    case a.cash_on_delivery:
      return /* @__PURE__ */ e(f, { ...r });
    case a.xendit_id_card:
    case a.xendit_ph_card:
      return /* @__PURE__ */ e(y, { ...r });
    case a.paystack_gh_card:
    case a.paystack_ke_card:
    case a.paystack_ng_card:
    case a.paystack_za_card:
    case a.paystack_eg_card:
    case a.paystack_ci_card:
      return /* @__PURE__ */ e(I, { ...r });
  }
};
export {
  O as getPaymentMethodIcon
};
